export const PATTERNS_CONSTANTS = {
  email: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g,
  username: /^[\w\.\-]+$/g,
  // username: /^[\w\.\-@]+$/g,
  url: /^(?!http:\/\/)(https:\/\/)?(www\.)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w@%+.*^!()$~-]*)*(\?[^\s,]*|$)?(\/[^\s,]*)?(#[^\s,]*)?$/gi,
};
